import { render } from "./kbreview.vue?vue&type=template&id=6fd35ea4&scoped=true"
import script from "./kbreview.vue?vue&type=script&lang=js"
export * from "./kbreview.vue?vue&type=script&lang=js"

import "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&lang=css"
import "./kbreview.vue?vue&type=style&index=1&id=6fd35ea4&scoped=true&lang=css"

import exportComponent from "E:\\mydemo\\issue-security-vue\\issuebye-fore\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fd35ea4"]])

export default __exports__